var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-tag-2022-2-10-09-45-54", class: _vm.size },
    [
      _c(
        "el-tag",
        {
          class: _vm.color,
          attrs: {
            closable: _vm.closable,
            "disable-transitions": _vm.disableTransitions,
            size: _vm.size,
          },
          on: { close: _vm.handleCloseTag },
        },
        [_vm._t("default"), _vm._v(_vm._s(_vm.text))],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }